import { useState } from "react";
import Styles from "./InfoPage.module.scss";
import { OldGrid } from "src/components/atoms/OldGrid/OldGrid";
import { OldRow } from "src/components/atoms/OldGrid/OldRow";
import { Title } from "src/components/atoms/Title/Title";
import { TabViewChooser } from "src/components/compounds/TabViewChooser/TabViewChooser";
import { TeamRoster } from "src/components/compounds/TeamRoster/TeamRoster";
import { TeamStaff } from "src/components/compounds/TeamStaff/TeamStaff";
import { useOutletContext, useParams } from "react-router-dom";
import { useGetTeamPlayersByIDQuery } from "src/state/modules/api";
import PageLoader1 from "src/components/atoms/PageLoader/PageLoader";
import * as Team from "src/state/modules/team";
const InfoPage = () => {
  const team = useOutletContext<Team.Team>();
  const { id } = useParams();
  const teamID = id ?? "";
  const views = ["Roster", "Staff"];
  const [currentView, setCurrentView] = useState(views[0]);
  const { data: players } = useGetTeamPlayersByIDQuery(teamID);

  if (!(team && players)) return <PageLoader1 />;

  return (
    <OldGrid className={Styles.teamInfoPageContainer} centered={false}>
      <Title text={"Team"} />
      <OldRow padded={false} className={Styles.viewSelector}>
        <TabViewChooser
          variant="selector"
          options={views}
          active={currentView}
          onClick={(view) => setCurrentView(view)}
        />
      </OldRow>
      {currentView === "Roster" ? <TeamRoster team={team} players={players} /> : <TeamStaff team={team} />}
    </OldGrid>
  );
};

export default InfoPage;
